<template>
    <section class="font-poppins">
        <div class="flex justify-between" >
            <div class="w-2/3 md:w-full md:p-2">
                <div class="flex justify-between mt-8">
                    <router-link to="/"><img class="md:w-1/2 w-4/5 pl-3"  src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
                    <p class="mr-10 text-blue-600 text-2xl md:text-sm">4/4</p>
                </div>

                <div class="flex justify-center">
                    <div>
                        <div class="text-4xl mt-10 md:text-lg">
                            <h2 class="text-blue-600 font-semibold " style="color:rgb(18,84,179)">Sign Up for HP Scheme</h2>
                        </div>
                        <div class="w-4/5 md:w-full">
                            <div class="mt-8 font-semibold">
                                <p>Upload Document</p>
                                <p class="mt-1 font-medium">upload only pdf, jpg, jpeg or png</p>
                            </div>
                            <div class="mt-5">
                                <p class="text-red-500 text-sm">{{error}}</p>
                                <form @submit.prevent="submitDetails" enctype="multipart/form-data">
                                    <div>
                                        <div>
                                            <label for="selectedIdCard" class=" font-bold">ID Card Type</label><br>
                                            <select class="bg-gray-100 border w-full p-1 rounded-lg" name="selectedIdCard" id="selectedIdCard" v-model="selectedIdCard">
                                                <option value="" disabled>Select ID Card Type</option>
                                                <option value="Voters Card">Voters Card</option>
                                                <option value="ID Card">National ID Card</option>
                                                <option value="Reg. Company Card">Reg. Company Card</option>
                                            </select>
                                            <p v-if="selectedIdCardValidity" class=" text-xs text-red-500">this field must not be empty</p>

                                            <div>
                                                <input style="display:none" type="file" name="idCard" id="idCard" @change="onIdCard" ref="idCardUpload">
                                                <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.idCardUpload.click()">--upload file-- {{this.idCardName}} </p>
                                                <p v-if="idCardValidity" class=" text-xs text-red-500">please upload a file</p>
                                                <p v-if="idFileError" class=" text-xs text-red-500">{{idFileError}}</p>
                                            </div>
                                            
                                        </div>

                                        <div class="mt-4">
                                            <div>
                                                <label class="font-bold" for="passort">Passport</label>
                                                <input style="display:none" type="file" name="passport" id="passport" @change="onPassport" ref="passportUpload">
                                                <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.passportUpload.click()">--upload file-- {{this.passportName}} </p>

                                                <p v-if="passportValidity" class=" text-xs text-red-500">please upload a file</p>
                                                <p v-if="passportFileError" class=" text-xs text-red-500">{{passportFileError}}</p>
                                            </div>

                                        </div>
                                        <!-- <div class="mt-4 ">
                                            <input class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" type="text" name="chasis" id="chasis" placeholder="Chasis Number">
                                        </div> -->

                                        <div class="mt-4">
                                            <label for="OriginCertificate" class=" font-bold">Certificate of Origin</label><br>
                                            <input style="display:none" type="file" name="originCertificate" id="state-certificate" @change="onOriginCertificate" ref="originUpload">
                                            <p class="w-full bg-gray-100 p-1 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.originUpload.click()">--upload file-- {{this.originCertificateName}} </p>
                                            <p v-if="originCertificateValidity" class=" text-xs text-red-500">please upload a file</p>
                                            <p v-if="certFileError" class=" text-xs text-red-500">{{certFileError}}</p>
                                        </div>
                                        <!-- <div class="mt-4">
                                            <label for="healthCertificate" class=" font-bold">Health/Fitness Certificate</label><br>
                                            <input style="display:none" type="file" name="healthCertificate" id="healthCertificate" @change="onHealthCertificate" ref="healthCertificateUpload">
                                            <p class="w-full p-1 bg-gray-100 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.healthCertificateUpload.click()">--upload file--{{this.healthCertificateName}}</p>
                                            <p v-if="healthCertificateValidity" class=" text-xs text-red-500">please upload file</p>
                                        </div> -->

                                        <!-- <div class="mt-4">
                                            <label for="guarantor" class=" font-bold">Guarantor's Form</label><br>
                                            <input style="display:none" type="file" name="guarantor" id="guarantor" @change="onGuarantorForm" ref="guarantorUpload">
                                            <p class="w-full p-1 bg-gray-100 rounded-lg border pl-2 mt-1 text-left text-gray-500" @click="$refs.guarantorUpload.click()">--upload file--{{this.guarantorFormName}}</p>
                                            <p v-if="guarantorFormValidity" class=" text-xs text-red-500">please upload file</p>
                                        </div> -->
                                    </div>

                                    <div>
                                        <div class="flex mt-5 text-sm">
                                            <input  type="checkbox" class="mt-2 mr-4" name="t&c" id="t&c" v-model="checkbox">
                                            <p>By creating an account, you are agreeing to our
                                                <a @click="showPolicy" class="text-blue-500 cursor-pointer" >Terms of service</a> and <a @click="showPolicy" class="text-blue-500 cursor-pointer">Privacy policy</a>
                                            </p>
                                        </div>
                                        <p v-if="checkValidity" class=" text-xs text-red-500">Accept T&C to proceed</p>
                                    </div>
                                    <div class="mt-10 flex pb-8" >
                                        <button type="submit" class="w-full text-white rounded p-1" style="background-color:rgb(18,84,179)" >Proceed</button>
                                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                                    </div>
                                </form>                              
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                
            </div>

            <div class="image w-1/3 md:hidden">

            </div>
        </div>

        <div class="lg:hidden mt-16">
            <the-footer/>
        </div>
        <div>
            <TermsPolicyModal
            v-show="termsPolicy"
            @close="closeModal"
            />
        </div>
    </section>
</template>

<script>
import TermsPolicyModal from '../TermsPolicyModal.vue';
import axios from 'axios';
import {baseUrl} from '../../../../Config';
const url = baseUrl;
export default {
    components:{TermsPolicyModal},

    data() {
        return {
            emailInput: '',
            selectedIdCard: '',
            idCard: null,
            idCardName: null,
            passport: null,
            passportName: null,
            originCertificate: null,
            originCertificateName: null,
            checkbox: '',
            
            selectedIdCardValidity: false,
            idCardValidity: false,
            passportValidity: false,
            originCertificateValidity: false,
            checkValidity: false,

            isLoading: false ,
            error: "",
            termsPolicy:"",
            idFileError: "" ,
            certFileError: "",
            passportFileError: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
         showPolicy() {
            this.termsPolicy = true;
        },
         closeModal() {
            this.termsPolicy = false;
        },
        onIdCard(event) {
            this.idCard = event.target.files[0]
            this.idCardName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.idFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.idFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.idFileError = "";
                }, 1000);
            }
        },
        onPassport(event) {
            this.passport = event.target.files[0]
            this.passportName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.passportFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.passportFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.passportFileError = "";
                }, 1000);
            }
        },
        onOriginCertificate(event) {
            this.originCertificate = event.target.files[0]
            this.originCertificateName = event.target.files[0].name
            if(!['image/png','image/jpeg','image/jpg', "application/pdf"].includes(event.target.files[0]['type'])){
                this.certFileError = "File type must only be png, jpeg, jpg, pdf."
            }else if(event.target.files[0]['size'] > 5000000){
                this.certFileError = "File must be less than 5MB"
            }else {
                setTimeout(() => {
                    this.certFileError = "";
                }, 1000);
            }
        },
        // onHealthCertificate(event) {
        //     this.healthCertificate = event.target.files[0]
        //     this.healthCertificateName = event.target.files[0].name
        // },
        // onGuarantorForm(event) {
        //     this.guarantorForm = event.target.files[0]
        //     this.guarantorFormName = event.target.files[0].name
        // },
        
        submitDetails() {
            this.networkError();
            if (!this.selectedIdCard) {
                this.selectedIdCardValidity = true;
                setTimeout(() => {
                    this.selectedIdCardValidity = false;
                    }, 4000);
            } else if (!this.idCard) {
                this.idCardValidity = true;
                setTimeout(() => {
                        this.idCardValidity = false;
                    }, 4000);
            } else if (!this.passport) {
                this.passportValidity = true;
                setTimeout(() => {
                        this.passportValidity = false;
                    }, 4000);
            } else if (!this.originCertificate) {
                this.originCertificateValidity = true;
                setTimeout(() => {
                        this.originCertificateValidity = false;
                    }, 4000);
            } else if(!this.checkbox) {
                this.checkValidity = true;
                setTimeout(() => {
                        this.checkValidity = false;
                    }, 4000);
            }
            else if(!this.idFileError && !this.passportFileError && !this.certFileError){
                this.isLoading = true;
                let data = new FormData()
                data.append('email', localStorage.getItem("hpEmail"));
                data.append('selectedIdCard', this.selectedIdCard); 
                data.append('idCard', this.idCard); 
                data.append('passport', this.passport); 
                data.append('originCertificate', this.originCertificate); 
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/riders/update`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data:data
                })
                .then((response) => {
                    response.json
                    localStorage.removeItem("hpEmail");
                    localStorage.removeItem("hpPhone")
                    this.$router.push('/success');
                    this.$store.commit("setAuthentication", true)  ;          
                    this.isLoading = false;
                })

                .catch((error) => {
                    this.error = error.response.data.message
                    setTimeout(() => {
                        this.error = false;
                    }, 4000);
                    this.isLoading = false;
                });
            }
        },
        networkError() {
        if(!navigator.onLine) {
            this.$router.push('/network-error')
        } 
    }
    }
}
</script>

<style scoped>
.image {
    background-image: url("../Image/sea.png");
    background-repeat: no-repeat;
}
</style>
